import script from "./Socks5Proxies.vue?vue&type=script&setup=true&lang=ts"
export * from "./Socks5Proxies.vue?vue&type=script&setup=true&lang=ts"

import "./Socks5Proxies.vue?vue&type=style&index=0&id=5924d584&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5924d584"]])

export default __exports__